import antdRu from 'antd/lib/locale-provider/ru_RU';
import appLocaleData from 'react-intl/locale-data/ru';
import rbac from '../locales/ru/rbac';
import clients from '../locales/ru/client';
import tasks from '../locales/ru/task';
import services from '../locales/ru/service';
import projects from '../locales/ru/project';
import common from '../locales/ru/common';
import users from '../locales/ru/user';
import credentials from '../locales/ru/credential';
import account from '../locales/ru/account';
import articles from '../locales/ru/article';
import events from '../locales/ru/event';
import legalEntity from '../locales/ru/legalEntity';
import comments from '../locales/ru/comment';
import timer from '../locales/ru/timer';
import file from '../locales/ru/file';
import notifications from '../locales/ru/notifications';
import home from '../locales/ru/home';
import report from '../locales/ru/report';
import emoji from '../locales/ru/emoji';
import setUpWizard from '../locales/ru/setUpWizard.json';
import help from '../locales/ru/help';
import iso3166countries from '../locales/ru/iso3166codes.json';
import search from '../locales/ru/search';

const RuLang = {
  messages: {
    ...rbac,
    ...clients,
    ...tasks,
    ...services,
    ...projects,
    ...users,
    ...credentials,
    ...common,
    ...account,
    ...articles,
    ...events,
    ...legalEntity,
    ...comments,
    ...timer,
    ...file,
    ...notifications,
    ...home,
    ...report,
    ...emoji,
    ...setUpWizard,
    ...help,
    ...iso3166countries,
    ...search,
  },
  antd: antdRu,
  locale: 'ru',
  data: appLocaleData,
};

export default RuLang;
